import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { TabList, Tab, TabPanel } from "@similarweb/ui-components";

export const INTEGRATION_WIDTH = "1054px";
export const INTEGRATION_WIDTH_LARGE = "1366px";

export const integrationMaxWidth = css`
    max-width: ${INTEGRATION_WIDTH};

    @media (min-width: 1920px) {
        max-width: ${INTEGRATION_WIDTH_LARGE};
    }
`;

export const integrationMinWidth = css`
    min-width: ${INTEGRATION_WIDTH};

    @media (min-width: 1920px) {
        min-width: ${INTEGRATION_WIDTH_LARGE};
    }
`;

export const StyledExportPage = styled.div`
    height: 100vh;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`;

export const StyledExportPageContent = styled.div`
    padding: 32px 0 0;
    margin: 0 auto;
    width: 100%;

    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    ${integrationMaxWidth}
`;

export const StyledExportPageTitle = styled.div`
    ${setFontVariant("h4")};
    color: ${colorsPalettes.carbon[500]};
    line-height: 32px;
`;

export const StyledExportPageSubTitle = styled.div`
    ${setFontVariant("body1")};
    color: ${colorsPalettes.carbon[300]};
    line-height: 20px;
`;

export const StyledMissingRequiredFieldsWarning = styled.p`
    ${setFontVariant("body2")};
    line-height: 16px;
    color: ${colorsPalettes.red["s100"]};
    margin: 8px 0 13px;
`;

export const StyledTabList = styled(TabList)`
    display: flex;
    justify-content: space-between;
    margin: 0;
    border: none;
`;

export const StyledTabButtonWrapper = styled.div`
    padding-right: 20px;
`;

export const StyledTabsWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
`;

export const StyledTabPanel = styled(TabPanel)`
    height: calc(100% - 46px);
`;

export const StyledTab = styled(Tab)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 15px 32px;
`;

export const StyledTabHeaderLabel = styled.span`
    ${setFontVariant("tab")};
`;
